export function cmToFeet(height) {
  var realFeet = (height * 0.3937) / 12;
  var feet = Math.floor(realFeet);
  var inches = Math.round((realFeet - feet) * 12);
  return feet + "'" + inches;
}
